import React from "react";
// import AppointmentsComponent from "../modules/appointment/Appointment";
import AppointmentsComponent from "../modules/Appointments/index";

function Appointments() {
  return <AppointmentsComponent />;
}

export default Appointments;
